import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { GLOBAL_MEETING_DATA } from "../../../../constants/PublicVariables";

const BrandingDetailScreen = () => {
    const { isCompanyAvailableData, privacyPolicyLoading, privacyPolicyData, privacyPolicyError } = useSelector((state) => state.onLoadData);

    const { agentPortalName, guestPortalName } = useSelector((state) => state.language);

    /* Handle to show company Logo is visible or not */
    const companyLogo = useMemo(() => {
        if (privacyPolicyLoading || privacyPolicyError || privacyPolicyData) {
            if (!privacyPolicyError && !privacyPolicyLoading) {
                GLOBAL_MEETING_DATA.companyLogo = process.env.REACT_APP_COM_URL + privacyPolicyData?.logoImage;
            }
            return GLOBAL_MEETING_DATA.companyLogo;
        } else if (isCompanyAvailableData) {
            GLOBAL_MEETING_DATA.companyLogo = process.env.REACT_APP_COM_URL + isCompanyAvailableData?.domainLogo;
            return GLOBAL_MEETING_DATA.companyLogo;
        }
    }, [isCompanyAvailableData, privacyPolicyData, privacyPolicyError]);

    const companyName = useMemo(() => {
        return GLOBAL_MEETING_DATA.isAgent ? agentPortalName : guestPortalName;
    }, [agentPortalName, guestPortalName]);

    return (
        <div className='branding-detail'>
            {(companyLogo || GLOBAL_MEETING_DATA.companyLogo) && (
                <div className='domain-logo' data-testid='brandLogo'>
                    <img
                        className='domain-img'
                        data-testid='brandLogoImg'
                        id='brandLogo'
                        src={companyLogo || GLOBAL_MEETING_DATA.companyLogo}
                        alt=''
                    />
                </div>
            )}
            {companyName && (
                <div className='domain-name' data-testid='domainName'>
                    {companyName}
                </div>
            )}
        </div>
    );
};

export default BrandingDetailScreen;
